export default __webpack_public_path__ + "static/N0134-db38fb6443040b5789bf390040ee65b0.png";